import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import { getUser, clearAuth } from '../utils/authUtil';

const Navbar = ({ onMenuClick, notifCount, userRole }) => {
  const navigate = useNavigate();
  const user = getUser();
  const userName = user?.name || 'User';

  return (
    <nav className="navbar">
      <div className="nav-left">
        <button className="hamburger-btn" onClick={onMenuClick}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <span className="navbar-brand">Zaptude</span>
      </div>

      <div className="nav-right">
        <div className="nav-profile-container">
          <div className="nav-profile-circle">
            {userName[0].toUpperCase()}
          </div>
          <div className="profile-hover-card">
            <div className="phc-header">
              <div className="phc-avatar">{userName[0].toUpperCase()}</div>
              <div className="phc-details">
                <div className="phc-name">{userName}</div>
                <div className="phc-role">{user?.role?.replace('_', ' ')}</div>
              </div>
            </div>
            <div className="phc-body">
              <div className="phc-info-item">
                <span className="phc-icon">📧</span>
                <span className="phc-text">{user?.email}</span>
              </div>
              {user?.collegeName && (
                <div className="phc-info-item">
                  <span className="phc-icon">🏛️</span>
                  <span className="phc-text">{user.collegeName}</span>
                </div>
              )}
              {user?.branch && (
                <div className="phc-info-item">
                  <span className="phc-icon">🎓</span>
                  <span className="phc-text">{user.branch}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
